import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { AuthState } from '../../store/auth/auth.state';
import { EnvironmentService } from '../../core/services/environment.service';
import { DashboardConfiguration } from '../../feature-modules/data-models/dashboard-config.model';
import { External } from '../decorators/app.decorators';

@External()
@Injectable({
  providedIn: 'root'
})
export class WhitneyService {

  readonly calculatorCode = "pcs";
  config: any;
  constructor(private http: HttpClient, private store: Store, private envService: EnvironmentService) {
    this.config = this.envService.config;
   }

  getSupportConfiguration(configuration: string): Observable<DashboardConfiguration[]> {
    let token: string | undefined = this.store.selectSnapshot(AuthState.getAccessToken);
    if(!token) {
      token = ''
    }
    return this.http.get<DashboardConfiguration[]>(`${this.config.whitneyConfigUrl}/${this.calculatorCode}/${configuration}/supportedvalues?locale=en`);
   }

  getLiveOpticsFileConfig(file:any):Observable<any>{
    return this.http.post<any>(`${this.config.whitneyConfigUrl}/${this.calculatorCode}/lo/configuration/excel`, file, {
      reportProgress: true, // <--- This is the key!
      responseType: 'json', // Expecting JSON response from the server
      observe: 'events'
    });
  }

  getRVToolsFileConfig(file:any):Observable<any>{
  return this.http.post<any>(`${this.config.whitneyConfigUrl}/${this.calculatorCode}/rvtools/configuration/excel`, file, {
      reportProgress: true, // <--- This is the key!
      responseType: 'json', // Expecting JSON response from the server
      observe: 'events'
    });
  }
}
